import { useMemo } from "react";
import { BillingService } from "@/services/BillingService";
import { isApiErrorStatus } from "@/api/ApiError";
import { useQuery } from "@tanstack/react-query";

export function useOrganisationBillingSummaryQuery(orgId: string | null | undefined) {
  const billingService = useMemo(() => new BillingService(), []);

  return useQuery({
    queryKey: ["organisation-billing-summary", orgId],
    queryFn: () => billingService.getOrganisationBillingSummary(orgId!),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    // A 404 means the endpoint isn't live yet (deploy gap) or the org doesn't exist — fail fast.
    retry: (failureCount, error) => !isApiErrorStatus(error, 404) && failureCount < 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}
